import { Component, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { RequestsService } from 'src/app/_shared/services/requests.service'
import { formatDatesRanges } from 'src/app/_shared/utils/formatDates'
import { ReferralService } from '../referral.service'

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['../referrals.component.scss'],
})
export class ReferralsComponent implements OnInit {
  isLoading: boolean = false
  activePage: number = 1
  limit: number = 20
  data: any[] = []
  search: any
  rangeDates: Date[]

  searchControl = new FormControl()

  commissionRate$ = this.referralService.referralsCommissionRate$
  referralsData$ = this.referralService.referrals$

  constructor(
    private requestService: RequestsService,
    private referralService: ReferralService
  ) {}

  ngOnInit() {
    this.getData()
  }

  getData(params: { [key: string]: any } = {}, load = true) {
    this.referralService.loadReferrals(this.getParams(params))
  }

  getParams(data: any = {}) {
    // add salt to refetch the data incase of any updates
    let { salt, ...rest } = data
    salt = salt ? Math.round(Date.now() / 1000) * 1000 : null
    const obj = {
      limit: this.limit,
      page: this.activePage,
      search__like: this.searchControl.value,
      salt,
      ...formatDatesRanges(this.rangeDates),
      ...rest,
    }
    Object.keys(obj).forEach(
      (key) => (obj[key] == null || obj[key] == '') && delete obj[key]
    )
    return obj
  }
  displayActivePage(activePageNumber: number) {
    this.activePage = activePageNumber
    this.getData()
  }
}
